export default {
  fields: {
    code: 'Code',
    tag: 'Tag',
    type: 'Type',
    discount_type: 'Kortingstype',
    discount: 'Korting',
    usage_threshold: 'Gebruiksdrempel',
    quantity: 'Aantal',
    expires_at: 'Verloopt',
    customers: 'Klanten',
    purchases: 'Bestellingen',
    sales: 'Verkopen',
    level: 'Niveau',
    max_discount: 'Max. korting',
  },
  tags: {
    master: 'Master',
    campaign: 'Campagne',
    one_time: 'Eenmalig',
  },
  types: {
    single_use: 'Eenmalig gebruik',
    multi_use: 'Meervoudig gebruik',
    unknown: 'Onbekend',
  },
  discount_types: {
    fixed_amount: 'Vast bedrag',
    percentage: 'Percentage',
    unknown: 'Onbekend',
  },
  labels: {
    discount: 'Korting',
    usage_threshold: 'Gebruiksdrempel',
    company: 'Bedrijf',
  },
  collecting_emails: {
    description:
      'Hier kunt u de eenmalige promocode instellen voor nieuwe gebruikers die zich aanmelden op de website.',
  },
  buttons: {
    edit: 'Bewerken',
  },
  toasts: {
    successfully_deleted: 'Promocode-instellingen verwijderd',
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
